module.exports = __webpack_public_path__ + "static/media/ic_small_close.ef49f8a1.svg";